<template>
  <div class="container-become-agent" :style="`paddingTop:${barHeight}px`">
    <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
      <template #left>
        <img class="left-nav" src="@/assets/packageAssets/common/arrow05.png" alt="" @click-left="closeWeb" />
      </template>
    </van-nav-bar>
    <div class="main">
      <div class="logo">
        <img :src="getMatchImg('app-logo')" alt="" />
        <span>{{ $t('lang.bc.tit') }}!</span>
      </div>
      <div class="item">
        <div class="text">1.{{ $t('lang.bc.tit1') }}</div>
        <input type="text" v-model="youFrom" />
      </div>
      <div class="item">
        <div class="text">2.{{ $t('lang.bc.tit2') }}</div>
        <input type="text" :placeholder="$t('lang.bc.inputTit1')" v-model="theyFrom" />
      </div>
      <div class="item">
        <div class="text">3.{{ $t('lang.bc.tit3') }}</div>
        <input type="text" :placeholder="$t('lang.bc.inputTit2')" v-model="contact" />
      </div>
      <div class="item">
        <div class="text item4">4.{{ $t('lang.bc.tit4') }}</div>
        <van-uploader :after-read="afterRead" v-model="fileList" :max-count="5" @delete="(file, detail) => deleteImg(file, detail)" :multiple="multiple" />
      </div>
      <div v-if="this.code" class="submit" :class="{ submitflag: youFrom && theyFrom && contact && flag && fileList.length > 0 }" @click="handleSubmit">
        <span v-if="codeFlag">{{ $t('lang.bc.goInvite') }}</span>
        <span v-else>{{ $t('lang.bc.submit') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { apiFetchUserAccountInfo, apiAgentApply, getAwsInfoApi } from '@/api/imee.js'
import { decryptCode } from '@/utils/common.js'
import { pk } from '@/config/common.js'

import AWS from 'aws-sdk'

export default {
  components: {},
  props: {},
  data() {
    let query = this.$route.query
    return {
      barHeight: query.statusBarHeight || 38,
      name: query.name || '',
      youFrom: null,
      theyFrom: null,
      contact: null,
      fileList: [],
      s3: null,
      suffix: '',
      fileName: '',
      fileUpload: null,
      // 防止重复点击
      loading: false,
      // 后端需要的图片参数
      fileUploadImgList: [],
      status: '',
      code: '',
      codeFlag: false,
      flag: false,
      appType: ''
    }
  },
  created() {
    const appName = this.getAppName()
    if (this.appNameFlag('vava', appName)) {
      this.appType = 'vava'
    }
    if (this.appNameFlag('echo', appName)) {
      this.appType = 'echo'
    }
    if (this.appNameFlag('joychat', appName)) {
      this.appType = 'joychat'
    }
    if (this.appNameFlag('goparty', appName)) {
      this.appType = 'goparty'
    }
    if (this.appNameFlag('joylink', appName)) {
      this.appType = 'joylink'
    }

    this.getBeforeUploadInfo()
    this.fetchUserAccountInfo()
  },
  methods: {
    // 获取用户信息
    fetchUserAccountInfo() {
      apiFetchUserAccountInfo().then((res) => {
        this.code = res.locationCode
        this.codeFlag = ['BR', 'CO', 'VE', 'AR', 'CL', 'EC', 'ES', 'UY', 'MX', 'PE', 'PT'].includes(this.code)
      })
    },

    afterRead(e) {
      e.status = 'uploading'
      var that = this
      let file = e.file
      if (file) {
        that.fileName = file.name
        that.loading = true
        var key = 'public/picture/agent/' + that.getUid() + '_' + file.lastModified + '/' + that.fileName

        var params = {
          Bucket: 'relationcoachf70d843ba0934dfebf4f63dcdb5f9158102154-dev',
          Key: key,
          Body: file
        }
        that.fileUpload = that.s3.upload(params, function (err, data) {
          if (err) {
            that.fileList.length = 0
            that.loading = false
            that.flag = false
          } else {
            e.status = 'done'
            that.flag = true
          }
        })
      }
    },
    deleteImg(file, detail) {
      if (this.fileList.length == 0) {
        this.flag = false
      }
    },
    // 提交
    handleSubmit() {
      if (this.fileList.length == 0) {
        return
      } else {
        this.fileList.forEach((item) => {
          this.fileUploadImgList.push('public/picture/agent/' + this.getUid() + '_' + item.file.lastModified + '/' + item.file.name)
        })
      }

      // 去重
      let arrSet = [...new Set(this.fileUploadImgList)]
      let params = {
        contactWay: this.contact,
        country: this.youFrom,
        otherWorkingPlatform: this.theyFrom,
        otherWorkingPlatformIncomeImage: arrSet
      }
      apiAgentApply(params).then((res) => {
        if (res.status == 200) {
          this.$client.showToast(res.message)
          this.fileUploadImgList.length = 0
          this.youFrom = null
          this.theyFrom = null
          this.contact = null
          this.fileList.length = 0
          this.fileList = []
          if (['BR', 'CO', 'VE', 'AR', 'CL', 'EC', 'ES', 'UY', 'MX', 'PE', 'PT'].includes(this.code)) {
            this.$router.push('/invite')
          }
        }
        // 异常处理
        else {
          this.fileUploadImgList.length = 0
          this.fileList.length = 0
          this.fileList = []
        }
      })
    },
    getBeforeUploadInfo() {
      getAwsInfoApi().then((resData) => {
        try {
          let jsonObj = JSON.parse(decryptCode(resData, pk))
          // AWS 认证相关
          this.s3 = new AWS.S3({
            accessKeyId: jsonObj.accessKeyId,
            secretAccessKey: jsonObj.secretAccessKey,
            region: jsonObj.region
          })
        } catch (err) {
          console.log('try catch', err)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.container-become-agent {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  .main {
    padding: 0 16px 30px;
  }
  .logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #000;
    font-weight: 600;
    font-family: Inter-Regular, Inter;
    margin-bottom: 26px;
    > img {
      width: 90px;
      height: 90px;
      border-radius: 10px;
      margin-bottom: 20px;
    }
  }
  .item {
    font-size: 14px;
    font-family: Inter-Regular, Inter;
    .text {
      font-size: 14px;
      color: #333;
      font-weight: 500;
    }
    input {
      width: 100%;
      color: #333;
      border-bottom: 1px solid #ccc;
      margin: 10px 0 20px 0;
      font-size: 14px;
      padding: 5px;
    }
    .item4 {
      margin-bottom: 10px;
    }
  }
  .submit {
    width: 200px;
    height: 40px;
    margin: 30px auto;
    font-family: Inter-Regular, Inter;
    font-size: 18px;
    text-align: center;
    line-height: 40px;
    background: linear-gradient(90deg, #e72cc5 0%, #8931fe 100%);
    border-radius: 20px;
    color: #fff;
    pointer-events: none;
    filter: grayscale(100%);
  }
  .submitflag {
    pointer-events: auto;
    filter: grayscale(0);
  }
}
</style>
